/**
 * <k-eyes>: makes the pupils drawn over the KOOL logo follow the mouse.
 * Each [data-eye] holds one [data-pupil]; pupils move inside the eye up to
 * --k-travel (a fraction of the eye's width). Mouse only, never with reduced motion.
 */
class KEyes extends HTMLElement {
  #frame = 0;
  #eyes = [];

  #onMove = (event) => {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    const { clientX, clientY } = event;
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(() => {
      for (const eye of this.#eyes) {
        const rect = eye.getBoundingClientRect();
        const dx = clientX - (rect.left + rect.width / 2);
        const dy = clientY - (rect.top + rect.height / 2);
        const distance = Math.hypot(dx, dy) || 1;
        const travel = rect.width * 0.17;
        const reach = Math.min(1, distance / 120);
        const x = (dx / distance) * travel * reach;
        const y = (dy / distance) * travel * reach;
        eye.querySelector('[data-pupil]')?.style.setProperty('translate', `${x.toFixed(2)}px ${y.toFixed(2)}px`);
      }
    });
  };

  connectedCallback() {
    const canTrack = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
    if (!canTrack.matches) return;
    this.#eyes = [...this.querySelectorAll('[data-eye]')];
    window.addEventListener('pointermove', this.#onMove, { passive: true });
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.#frame);
    window.removeEventListener('pointermove', this.#onMove);
  }
}

if (!customElements.get('k-eyes')) {
  customElements.define('k-eyes', KEyes);
}
